import React from 'react';
import {
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Avatar,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Cart, CartTotals } from '../../../services/cartService';
import cartService from '../../../services/cartService';
import { useTranslation } from '../../../i18n';

interface ReviewStepProps {
    cart: Cart;
    totals: CartTotals | null;
    onBack: () => void;
    onNext: () => void;
}

const ReviewStep: React.FC<ReviewStepProps> = ({ cart, totals, onBack, onNext }) => {
    const { t } = useTranslation();

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {t('checkout.steps.review')}
            </Typography>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Produkt</TableCell>
                            <TableCell align="right">Preis</TableCell>
                            <TableCell align="center">Menge</TableCell>
                            <TableCell align="right">Summe</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {cart.items.map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Avatar
                                            variant="rounded"
                                            src={item.product?.thumbnailUrl || undefined}
                                            sx={{ width: 48, height: 48 }}
                                        >
                                            {item.product?.title?.[0] || '?'}
                                        </Avatar>
                                        <Box>
                                            <Typography variant="body2" fontWeight="medium">
                                                {item.product?.title || t('cart.unknownProduct')}
                                            </Typography>
                                            {item.price && (
                                                <Typography variant="caption" color="text.secondary">
                                                    {item.price.priceType === 'subscription'
                                                        ? `Abo - ${item.price.formattedPrice}`
                                                        : item.price.priceType === 'free'
                                                            ? 'Kostenlos'
                                                            : 'Einmalzahlung'
                                                    }
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell align="right">
                                    {cartService.formatAmount(item.unitPrice, totals?.currency)}
                                </TableCell>
                                <TableCell align="center">
                                    {item.quantity}
                                </TableCell>
                                <TableCell align="right">
                                    {cartService.formatAmount(item.lineTotal, totals?.currency)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                >
                    {t('cart.title')}
                </Button>
                <Button
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    onClick={onNext}
                >
                    Weiter
                </Button>
            </Box>
        </Box>
    );
};

export default ReviewStep;
